import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  TextField,
} from "@mui/material";
import React from "react";
import MDButton from "../../../components/MDButton/index";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "react-hook-form";
import MDInput from "../../../components/MDInput";
import { ProfessionDialogValidation } from "util/validations/commonValidations";
import { addProfession } from "../Redux/actionCreator";
import { useDispatch } from "react-redux";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ProfessionDialog = ({ handleDialogClose }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ProfessionDialogValidation),
  });

  const amount = watch("amount");
  const gst = watch("gst");

  const gstAmount = (Number(amount || 0) * Number(gst || 0)) / 100;

  const totalAmount = Number(amount || 0) + gstAmount;

  const selectOptions = [
    {
      key: "Organization",
      value: "Organization",
    },
    {
      key: "SuperAdmin",
      value: "Super_Admin",
    },
    {
      key: "Applicant",
      value: "Applicant",
    },
  ];

  const dispatch = useDispatch();
  const onSubmit = (data) => {

    const amountValue = Number(data.amount || 0);
    const gstValue = Number(data.gst || 0);

    const gstAmount = (amountValue * gstValue) / 100;

    const totalAmount = amountValue + gstAmount;

    const payload = {
      ...data,
      amount: amountValue,
      gst: gstValue,
      totalAmount,
    };

    
    dispatch(addProfession(payload));
    handleDialogClose();
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Name
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder="Enter Profession Type"
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              {...register("name")}
              error={errors?.name?.message}
              helperText={errors?.name?.message}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Minimum Hour
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder="Enter minimum hour"
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete" &&
                  e.key !== "ArrowLeft" &&
                  e.key !== "ArrowRight" &&
                  e.key !== "Tab"
                ) {
                  e.preventDefault();
                }
              }}
              {...register("minimumHour")}
              error={errors?.minimumHour?.message}
              helperText={errors?.minimumHour?.message}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Maximum Hour
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder="Enter maximum hour"
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete" &&
                  e.key !== "ArrowLeft" &&
                  e.key !== "ArrowRight" &&
                  e.key !== "Tab"
                ) {
                  e.preventDefault();
                }
              }}
              {...register("maximumHour")}
              error={errors?.maximumHour?.message}
              helperText={errors?.maximumHour?.message}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Amount
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder="Enter Amount"
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete" &&
                  e.key !== "ArrowLeft" &&
                  e.key !== "ArrowRight" &&
                  e.key !== "Tab"
                ) {
                  e.preventDefault();
                }
              }}
              {...register("amount")}
              error={errors?.amount?.message}
              helperText={errors?.amount?.message}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              GST(%)
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder="Enter Gst in percentage"
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete" &&
                  e.key !== "ArrowLeft" &&
                  e.key !== "ArrowRight" &&
                  e.key !== "Tab"
                ) {
                  e.preventDefault();
                }
              }}
              {...register("gst")}
              error={errors?.gst?.message}
              helperText={errors?.gst?.message}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Total Amount
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              value={totalAmount.toFixed(2)}
              disabled
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: {
                  fontSize: 15,
                  fontWeight: "bold",
                },
              }}
            />
          </Grid>
        </Grid>

        <MDButton
          variant="contained"
          color="info"
          type="submit"
          sx={{ marginTop: "1.5rem" }}
        >
          create
        </MDButton>
        {/* <MDButton variant="text" color="info" onClick={handleCloseDialog}>
                cancel
              </MDButton> */}
      </form>
    </div>
  );
};

export default ProfessionDialog;
